import { useEffect, useRef, useState } from 'react';
import { useRefreshMutation } from '@/entities/user';

/**
 * `POST /auth/refresh` (cookie) hydrates the session on first load — its response already carries
 * the user profile (see authApi.ts's `onQueryStarted`), so there's no separate `GET /me` call
 * here. Runs once; returns whether it's finished so `App.tsx` can hold the router behind a
 * full-page spinner until then.
 */
export function useBootstrap(): boolean {
  const [ready, setReady] = useState(false);
  const startedRef = useRef(false);
  const [refresh] = useRefreshMutation();

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    void (async () => {
      await refresh()
        .unwrap()
        .catch(() => null);

      setReady(true);
    })();
  }, [refresh]);

  return ready;
}
